import { useScroll, useTransform, motion } from "framer-motion";
import React, { useRef } from "react";
import './projects.css';
import Card from './card';
import Pulsar from '../../assets/pulsar.jpg';
import Tsunami from '../../assets/Tsunami.jpg';
import Movie from '../../assets/movie2.jpg';
import PeakMountain from '../../assets/peak.jpg';
import Seelie from '../../assets/seelie.png';
import Wellspring from '../../assets/wellspring2.png';
import Brewful from '../../assets/brewful.png';
import Lost from '../../assets/lostandfound.jpg';
import Github from "../../assets/github2.png"
import Figma from "../../assets/figma.png"
import Play from "../../assets/play.png"
import Devpost from "../../assets/devpost.svg"
import Linkedin from "../../assets/linkedin2.png"


export default function Projects() {

  return (
    <section id='Projects'>
        <div className='projects-container'>
            <div className='projects-title'>
                ~ some of my latest work ~
            </div>
            <div className='project-main'>
              <Card
               img={Seelie}
               name='Seelie'
               desc='A visually engaging banking app designed for Gen Z, simplifying financial management with intuitive charts and educational videos.'
               tech1={Figma}
               link1='https://www.figma.com/design/7KhB5MBPwAMuWfjsTcB456/Seelie?node-id=0-1&t=EQcF2LMwnYBAnDRM-1'
               tech2={Devpost}
               link2='https://devpost.com/software/seelie'
               />
               <Card
               img={Movie}
               name='Movie Recommendation System'
               desc='Developed a Python-based movie recommendation system using cosine similarity and movie dataset analysis for personalized suggestions.'
               tech1={Github}
               link1='https://github.com/RuhaniMittal29/Movie-Recommendation-System'
               />
               <Card
               img={Wellspring}
               name='WellSpring'
               desc='Wellness app finalist recognized for accessible design, built with React, JavaScript, and CSS, featuring routine tracking, progress reports, and API-integrated self-care tips.'
               tech1={Github}
               link1='https://github.com/RuhaniMittal29/WellSpring'
               tech2={Devpost}
               link2='https://devpost.com/software/wellspring-4g6zi9'
               tech3={Linkedin}
               link3='https://www.linkedin.com/posts/ruhanimittal_hackcamp2024-innovation-mostaccessibledesign-activity-7262577911826657280-tHAK?utm_source=share&utm_medium=member_desktop&rcm=ACoAADajzh4BQIYoAqEC1xtMCNWo30-t-6yWEdA'
               
               />
               <Card
               img={Pulsar}
               name='Pulsar Predictor'
               desc='Used k-nearest classification method to build a predictive model for identifying pulsars based on their signals and utilize data from integrated profiles and DM-SNR to classify them.'
               tech1={Github}
               link1='https://github.com/RuhaniMittal29/Pulsar-Predictor'
               />
               <Card
               img={Tsunami}
               name='Effects of the Magnitude of Earthquake on Tsunami'
               desc='Statistically analyzed real-world seismic data to test if mean magnitudes of tsunami-generating earthquakes differ from non-tsunami-generating ones, using summary statistics.'
               tech1={Github}
               link1='https://github.com/RuhaniMittal29/Effects-of-the-Magnitude-of-Earthquake-on-Tsunami'
               />
                <Card
               img={PeakMountain}
               name='Peak Mountain Resort - Case Competition'
               desc='Leveraged data analysis and NLP (DistilBERT, BERTopic) on customer reviews and operational data to identify safety issues, inefficiencies, and recommend improvements for a mountain resort.'
               tech1={Github}
               link1='https://github.com/RuhaniMittal29/PeakMountainResort'
               tech2={Linkedin}
               link2='https://www.linkedin.com/posts/ruhanimittal_thrilled-to-share-that-my-team-smrh-was-activity-7307604383536492545-Vyv8?utm_source=share&utm_medium=member_desktop&rcm=ACoAADajzh4BQIYoAqEC1xtMCNWo30-t-6yWEdA'
               />
               <Card
               img={Brewful}
               name='Brewful Bliss Cafe'
               desc='Developed a user-friendly and cozy interactive cafe website using React, JavaScript, and CSS to showcase the menu and history.'
               tech1={Github}
               link1='https://github.com/RuhaniMittal29/Cafe'
               tech2={Play}
               link2='https://brewfulblisscafe.netlify.app'
               />
               <Card
               img={Lost}
               name='Lost and Found System'
               desc='Developed a Lost and Found Management System using Next.js, PHP, and Oracle RDBMS with Git for version control, enabling efficient reporting, tracking, and claiming of lost items through a relational database.'
               tech1={Github}
               link1='https://github.com/RuhaniMittal29/Lost-and-Found-System'
               />
            </div>
        </div>
    </section>
  )
}
